import { BusinessOutlined } from '@mui/icons-material';
import { Box, Chip } from '@mui/material';

import { OrganizationViewModel } from '@/api';
import { PopulationVerticalResponse } from '@/api/api-client';
import { tableTypes } from '@/shared/components';
import { muiPalette } from '@/shared/general-theme';

export const organizationsColumns = (verticalsList: PopulationVerticalResponse[],
): tableTypes.ColumnProps<OrganizationViewModel>[] => [
  {
    title: 'Name',
    columnKey: 'name',
    sortable: true,
    cellInfo: {
      icon: <Box
        sx={{
          width: 36,
          height: 36,
          borderRadius: 1,
          backgroundColor: 'primary.light',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <BusinessOutlined sx={{ fontSize: 20, color: muiPalette.primary.main }} />
      </Box>,
      iconPosition: 'left',
      cellTextWeight: 700,
    },
  },
  {
    title: 'Domain',
    columnKey: 'domain',
    sortable: true,
  },
  {
    title: 'No of Assessments',
    columnKey: 'assessments',
    customCellRenderer(value) {
      return (
        <Chip
          label={value?.length ?? 0}
          size='small'
          sx={{
            fontWeight: 700,
            backgroundColor: muiPalette.primary.light,
            color: muiPalette.primary.main,
            borderRadius: '0.5rem',
          }}
        />
      );
    },
  },
  {
    title: 'Verticals',
    columnKey: 'verticals',
    customCellRenderer(value) {
      if (!value || value.length === 0) {
        return '-';
      }

      if (Array.isArray(value)) {
        return value.map(id => {
          const vertical = verticalsList.find(v => v.id === id);
          return vertical?.name ? <Chip
            key={vertical.id}
            label={vertical?.name}
            size='small'
            variant='outlined'
            sx={{ borderRadius: '0.5rem' }}
          /> : '-';
        });
      }

      return '-';
    },
  },
];